<template lang="pug">
v-expansion-panels
  v-expansion-panel
    v-expansion-panel-header.text-h6 How this works
    v-expansion-panel-content 
      p The purpose of this tool is to help you better understand which EV might best fit your needs. It uses map data to estimate the annual savings you could make, then finds an EV that suits your trips, and compares this to your old car.
      p By using this tool, you agree to these&nbsp;
        a(href="https://powertrip.earth/terms-and-conditions") terms and conditions
      p(v-if="mobile")
        v-icon mdi-map
        span Click or tap the map icon (top right) at any time to see your results on the map
      p
        v-btn(icon @click="showSettings")
          v-icon.pa-2 mdi-cogs
        span Click or tap on the cog icon at any time to fine tune the settings.
</template>
<script>
import { headerBus } from "../main";
export default {
  computed: {
    mobile() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
        case "sm":
        case "md":
          return true;
        default:
          return false;
      }
    },
  },
  methods: {
    showSettings() {
      headerBus.$emit("showSettings");
    }
  }
};
</script>
